// extracted by mini-css-extract-plugin
module.exports = {"custom":"_99c7625325409fd07a672f79795d7c6b-less"};